

const gallery = [
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_0.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_1.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_2.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_3.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_4.jpg",
  },

  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_5.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_6.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_7.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_8.jpg",
  },

  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_9.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_10.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_11.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_12.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_13.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_14.jpg",
  },
  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_15.jpg",
  },

  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_16.jpg",
  },

  {
    albumId: 1,
    id: 1,
    title: "bird",
    thumbnail: "img_t_17.jpg",
  },
];

export default gallery;
